import { useEffect } from 'react';
import DraggableSortItem from './draggable-sort-item';

const DraggableSortingContainer = ({ items, onChange, renderItem }) => {

    const handleDrop = (originalIndex, newIndex) => {
        if (originalIndex !== newIndex) {
            moveItem(originalIndex, newIndex);
        }
    };

    const moveItem = (fromIndex, toIndex) => {
        const updated = [...items];
        const [moved] = updated.splice(fromIndex, 1);
        updated.splice(toIndex, 0, moved);
        onChange(updated);
    };

    useEffect(() => {
    }, [items])

    return (
        <div>
            {items.map((item, index) => (
                <DraggableSortItem
                moveItem={handleDrop}
                renderItem={renderItem}
                item={item}
                index={index}
                key={item?.id ? item.id : item.custom_field_id} />
            ))}
        </div>
    );
}

export default DraggableSortingContainer;